<script>
export default {
    name: "AccessDenied"
}
</script>

<template>
    <div class="col-lg-9">
        <div>
            <div class="hover-border hover-section my-auto mx-auto py-5 bg-white shadow-sm rounded text-center px-3 py-4">
                <span class="d-block text-10 text-light mt-2 mb-3">
                    <i class="fas fa-ban service-icon"></i>
                </span>
                <p class="mb-0 text-3 service-text"><b>You do not have sufficient rights to access this feature</b></p>
                <small class="service-text-small">Contact your Admin for assistance</small>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
